// extracted by mini-css-extract-plugin
export default {"columnsDropdown":"columnsDropdown---hrjHf"};